<template>
  <div class="tab-content">
    <div v-for="(item, key) in data" :key="key" :id="`tab-${item.id}`" :class="{ 'active': currentTab === item.id }" class="tab-pane fade in">
      <div class="panel-body" v-html="item.content"></div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    currentTab: {
      type: Number,
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/premium/components/TabContent.vue